angular
  .module('caferealtor.help', ['ngRoute'])

  .config([
    '$routeProvider',
    function ($routeProvider) {
      $routeProvider.when('/help', {
        template: require('./help.html'),
        controller: 'HelpCtrl',
      });
    },
  ])

  .controller('HelpCtrl', ['$scope', function ($scope) {}]);
